import React, { useState, useEffect, useRef } from "react";
import {
  Alert,
  Grid,
  SpaceBetween,
  Spinner,
} from "@amzn/awsui-components-console";
import { FuseAccountingCentralDatastore } from "@amzn/fuse-accounting-central-datastore-client";
import { AuthService } from "src/auth/auth-service";
import FixedFeeConfigTableDisplay from "src/components/allFixedFeeConfigsPage/fixed-fee-configs-table-display";
import { FullPageTitle } from "src/components/header/title";
import {
  createAllRegionClients,
  listAllRegionConfigs,
} from "src/config/facd-all-regions";
import { RegionalDomain } from "src/config/BartLambdaConfig";
import { isProd } from "src/util/is-prod";
import "src/index.scss";

export const AppAllFixedFeeConfigs: React.FC = () => {
  const [authenticating, setAuthenticating] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [payload, setPayload] = useState<any>("init");
  const [ldap, setLdap] = useState("");
  const [clients, setClients] =
    useState<Record<RegionalDomain, FuseAccountingCentralDatastore>>();

  const authObj = useRef(new AuthService());

  useEffect(() => {
    const fetchData = async () => {
      await authObj.current.authenticate();
      setAuthenticating(false);
      setIsLoggedIn(authObj.current.getIsLoggedIn());
      setLdap(authObj.current.ldap);

      if (authObj.current.getIsLoggedIn()) {
        setPayload("init");
        await loadAllConfigs();
      }
    };
    fetchData();
  }, []);

  const loadAllConfigs = async () => {
    try {
      const allClients = await createAllRegionClients();
      setClients(allClients);
      const regionConfigs = await listAllRegionConfigs(allClients);
      const configs = regionConfigs.map((rc) => ({
        ...rc.config,
        region: rc.region,
      }));
      setPayload(configs);
    } catch (error: any) {
      console.error("An error occurred in listFixedFeeConfigs:", error);
      setPayload("error");
    }
  };

  return (
    <div>
      <FullPageTitle
        title={`View All FixedFee Configs${!isProd() ? " (Beta)" : ""}`}
        description="View all FixedFee Configs across all regions (NA, EU, FE)."
      />
      <SpaceBetween size="l" />
      {!(ldap.includes("bart-read-only") || ldap.includes("bart-admin")) ? (
        <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
          <Alert
            header="Only authorized users can access this page!"
            type="error"
          ></Alert>
        </Grid>
      ) : (
        <>
          {payload === "init" && <Spinner size="large" />}
          {payload === "error" && (
            <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
              <Alert header="Error in search!" type="error"></Alert>
            </Grid>
          )}
          {Array.isArray(payload) && payload.length === 0 && (
            <Grid gridDefinition={[{ colspan: { l: 7, xxs: 10 } }]}>
              <Alert header="No FixedFee Configs found" type="info"></Alert>
            </Grid>
          )}
          {Array.isArray(payload) && payload.length > 0 && (
            <SpaceBetween direction="vertical" size="m">
              <FixedFeeConfigTableDisplay
                searchResults={payload}
                clients={clients}
                onRefresh={loadAllConfigs}
              />
            </SpaceBetween>
          )}
        </>
      )}
    </div>
  );
};
